export enum DhcpDnsOption {
  CHOOSE_DHCP = 'choose_dhcp',
  CHOOSE_MANUAL = 'choose_manual',
}
